module.exports = __webpack_public_path__ + "i18n/zh-CN.3a167cded6e3d6bfd7b72e3bc776cb82.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1106
// module chunks = 76